// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_-gjb-GBS","dialogHeader":"_wC1olDJg","notion":"_DCOHlEVq","iconWrapper":"_9dSUk_mb","iframe":"_oHRA38Xd"};